module.exports = __webpack_public_path__ + "static/basil-50d66e36dc3d8bcc9bca387b5a6e66cf.jpg";